import React from "react"
import BasicErrorPage from "./BasicErrorPage"
import { withTranslation } from "react-i18next"

@withTranslation()
export default class NotFoundPage extends React.Component {
  render() {
    const { t } = this.props
    return <BasicErrorPage errorCode={404} errorTitle={t("notFoundPage")} />
  }
}
